import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ShimmerSnapshot } from "./shimmer-model.ts";

export interface ShimmerSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ShimmerSnapshot>>;
  readonly read: Effect.Effect<ShimmerSnapshot>;
  readonly receive: (active: boolean) => Effect.Effect<void>;
}
export class TextShimmers extends Context.Service<TextShimmers, {
  readonly open: (active: boolean) => Effect.Effect<ShimmerSession, never, Scope.Scope>;
}>()("workerstation/frontend/TextShimmers") {}
